import React from "react";
import "./montagem-template.scss";

interface PageTemplateProps {
  children: React.ReactNode;
  title: string;
  onClick?: () => void;
}

export function PageTemplate({ children, title, onClick }: PageTemplateProps) {
  return (
    <div className="page-template" onClick={onClick}>
      <p className="page-template__title">{title}</p>
      <div className="page-template__card">{children}</div>
    </div>
  );
}
